"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ClickableOptions = /** @class */ (function () {
    function ClickableOptions() {
    }
    return ClickableOptions;
}());
exports.ClickableOptions = ClickableOptions;
var Clickable = /** @class */ (function () {
    function Clickable(element, opts) {
        this.element = element;
        this.opts = opts;
        this.options = {
            targetSelector: 'data-target',
            urlSelector: 'data-url'
        };
        this.options = __assign({}, this.options, opts);
        this.target = this.element.getAttribute(this.options.targetSelector);
        this.url = this.element.getAttribute(this.options.urlSelector);
        this.init();
    }
    Clickable.prototype.init = function () {
        var _this = this;
        this.element.addEventListener('click', function (e) {
            return _this.ensureNoLink(e, function () { return _this.redirect(); });
        });
        this.element.addEventListener('mouseup', function (e) {
            return e.which === 2 &&
                _this.ensureNoLink(e, function () { return _this.redirectBlank(); });
        });
    };
    Clickable.prototype.ensureNoLink = function (e, cb) {
        if (this.isLinkClicked(e) === false) {
            cb();
        }
    };
    Clickable.prototype.isLinkClicked = function (e) {
        return e.target.nodeName === 'A';
    };
    Clickable.prototype.redirect = function () {
        if (this.isTargetBlank()) {
            this.redirectBlank();
        }
        else {
            window.location.href = this.url;
        }
    };
    Clickable.prototype.redirectBlank = function () {
        window.open(this.url, '_blank');
    };
    Clickable.prototype.isTargetBlank = function () {
        switch (this.target) {
            case '_blank':
            case 'blank':
                return true;
            case '_self':
            case 'self':
            default:
                return false;
        }
    };
    return Clickable;
}());
exports.Clickable = Clickable;
